import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet, useNavigate, useLocation } from "react-router";
import { loadGtag, trackPage } from './analytics';
import { useUserDataContext } from './contexts/userDataProvider';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import './scss/style.scss';
import { PropertyProvider } from './contexts/propertyProvider';
import { UserDataProvider } from './contexts/userDataProvider';
import { CoworkerRequestProvider } from './contexts/coworkerRequestProvider';
import { USER_STATUS_ACTIVE } from './components/common/utils';
import Login from './components/Login';
import Loader from './components/common/Loader';
import ErrorAlert from './components/common/ErrorAlert';
import CoworkerRequestModal from './components/settings/coworkers/CoworkerRequestModal';
import Search from './components/search/Search';
import Header from './components/Header';
import SidePanel from './components/SidePanel';
import TermsAndConditions from './components/terms/TermsAndConditions';
import EmailNotVerified from './components/EmailNotVerified';
import NotActivated from './components/NotActivated';
import NoPage from './components/NoPage';
import TimeLineView from './components/timeline/TimeLineView';

const MainWrapLayout = () => {
  const navigate = useNavigate();

  const { translate, data, isLoading, error } = useUserDataContext();
  const { nickname, isTermsAccepted, userStatus } = data && data[0] ? data[0] : {};

  useEffect(() => {
    if (userStatus !== undefined && userStatus !== USER_STATUS_ACTIVE) {
      navigate('/not-activated');
    }
  }, [userStatus, navigate]);

  const isUserDataReady = !isLoading && !!data?.length;

  return (
    <div className="main-wrap-layout">
      <Header
        translate={translate}
        nickname={nickname}
      />
      
      {isUserDataReady && (
        isTermsAccepted === true ? (
          <>
            <SidePanel />
            <CoworkerRequestModal />
            <ErrorAlert
              error={error}
              className={'header-error-alert'}
            />
            <Loader 
              setIsLoading={isLoading || !isUserDataReady}
            />
            <Outlet />
          </>
        ) : (
          <TermsAndConditions />
        )
      )}
    </div>
  );
};

// Analitics: track page views on route change
const RouteChangeTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Only enable analytics in production (CRA sets NODE_ENV during build)
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    (async () => {
      try {
        const loaded = await loadGtag();
        if (!loaded) {
          console.warn('gtag failed to load (possibly blocked by client)');
          return;
        }
        trackPage(location.pathname + location.search);
      } catch (e) {
        // ignore
      }
    })();
  }, [location]);

  return null;
};

const App = () => 
   (
    <BrowserRouter>
      <RouteChangeTracker />
      <PropertyProvider>
        <UserDataProvider>
          <CoworkerRequestProvider>
            <Routes>
              {/* Routes WITH header */}
              <Route element={<MainWrapLayout />}>
                <Route path="/app" element={<TimeLineView />} />
                <Route path="/search-view" element={<Search />} />
              </Route>
              {/* Routes WITHOUT header */}
              <Route path="/landing" element={<Login />} />
              <Route path="/email-not-verified" element={<EmailNotVerified />} />
              <Route path="/not-activated" element={<NotActivated />} />
              <Route path="*" element={<NoPage />} />
            </Routes>
          </CoworkerRequestProvider>
        </UserDataProvider>
      </PropertyProvider>
    </BrowserRouter>
  )

export default App;
